import { type ContractViolationError, createSisumailClient } from '@sisumail/api-client';
import { API_BASE_URL as CONFIG_API_URL } from '@sisumail/config';
import { toast } from 'sonner';
import { reportError } from './error-reporter';

const API_BASE_URL = import.meta.env.VITE_API_URL || CONFIG_API_URL;

// Get admin secret from localStorage
const adminSecret = localStorage.getItem('admin_secret');

export const api = createSisumailClient({
    baseUrl: API_BASE_URL,
    env: import.meta.env.MODE === 'production' ? 'production' : 'development',
    ...(adminSecret ? { adminSecret } : {}),
    onVersionMismatch: () => {
        toast.warning('Update Required', {
            description: 'The API version has breaking changes.',
            action: {
                label: 'Reload App',
                onClick: () => window.location.reload(),
            },
            duration: Infinity,
            dismissible: false,
            style: {
                background: '#f59e0b',
                color: '#fff',
                border: '1px solid #d97706',
            },
        });
    },
    onSchemaViolation: (error: ContractViolationError) => {
        const report = reportError(error);
        toast.error('Contract Violation (Bug)', {
            description: error.getSummary ? error.getSummary() : error.message,
            duration: 10000,
            action: report.traceId
                ? {
                      label: 'Copy Trace ID',
                      onClick: () => {
                          navigator.clipboard.writeText(report.traceId || '');
                          toast.success('Trace ID copied to clipboard');
                      },
                  }
                : undefined,
        });
    },
    onError: (error: { code: string; message: string }) => {
        if (error.code === 'UNAUTHORIZED') {
            localStorage.removeItem('admin_secret');
            window.location.href = '/login';
            return;
        }

        reportError(error);
        toast.error(`API Error: ${error.code}`, {
            description: error.message,
        });
    },
});

// Perform initial version handshake
api.checkVersion().catch((err: Error) => {
    const report = reportError(err);
    if (report.message?.includes('Failed to fetch')) {
        toast.error('Connection Failed', {
            description: 'Could not reach API. Check your connection.',
            duration: 10000,
            action: {
                label: 'Retry',
                onClick: () => window.location.reload(),
            },
        });
    }
});
